export interface CoveragePeriod {
  value: string;
  status: "received" | "missing";
}

const BALANCE_SHEET_SNAPSHOT_TABLE_TYPES = new Set([
  "balance_sheet",
  "ar_aging",
  "ar_by_debtor",
  "ap_aging",
  "ap_by_creditor",
  "inventory_aging",
  "inventory_by_type",
  "wip_by_type",
  "prepayments",
  "sundry_debtors",
  "sundry_creditors",
  "fixed_assets_register",
  "intangibles",
  "capex_commitments",
  "accrued_income",
  "accrued_expenses",
  "provisions",
]);

export function normalizeCoveragePeriods(
  tableType: string,
  months: CoveragePeriod[],
  years: CoveragePeriod[],
  financialYearEndMonth: number,
): { months: CoveragePeriod[]; years: CoveragePeriod[] } {
  if (!BALANCE_SHEET_SNAPSHOT_TABLE_TYPES.has(tableType)) {
    return { months, years };
  }

  const normalizedMonths = new Map(
    months.map((period) => [period.value, period.status]),
  );
  for (const period of years) {
    const closingMonth = `${period.value}-${String(financialYearEndMonth).padStart(2, "0")}`;
    const existingStatus = normalizedMonths.get(closingMonth);
    normalizedMonths.set(
      closingMonth,
      existingStatus === "received" || period.status === "received"
        ? "received"
        : "missing",
    );
  }

  return {
    months: Array.from(normalizedMonths, ([value, status]) => ({ value, status }))
      .sort((left, right) => left.value.localeCompare(right.value)),
    years: [],
  };
}
